<template>
  <div id="allStories">
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="content">
            <p class="title">{{currStoryText.title}}</p>
            <p class="subtitle">{{currStoryText.subtitle}}</p>
            <hr class="separator" />
            <div class="content">
              <p
                class="paragraph"
                v-for="(paragraph, index) of currStoryText.content"
                :key="index"
                v-html="paragraph"
              />
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import allStoriesJson from "../../public/AllStories.json";

export default {
  name: "allStories",
  props: {
    currStory: {
      type: String,
      required: false,
      default: "first"
    }
  },
  computed: {
      currStoryText() {
        return allStoriesJson[this.currStory]
      }
  }
};
</script>

<style scoped>
#allStories {
  direction: rtl;
}
.box {
  background-color: #fcfdf1;
  padding: 4.2vh;
}
.subtitle {
  padding-bottom: 2vh;
}
.separator {
  background: #666666;
  border-style: ridge;
  border-width: 1px;
}
.paragraph {
  text-align: justify;
}
</style>